<div class="main-wrapper">
  <div class="header-wrapper">
    <div class="logo-row">
      <div class="header-logo">
        <span><img src="../../../assets/img/Logo - maknetic_white.png" /></span>
      </div>
      <div class="header-language-selectors">
        <div (click)="changeLang('es')">
          <img
            style="margin-right: 8px"
            src="../../../assets/img/flags/es.png"
          />
        </div>
        <div (click)="changeLang('cat')">
          <img
            style="margin-right: 8px"
            src="../../../assets/img/flags/cat.png"
          />
        </div>
        <div (click)="changeLang('en')">
          <img src="../../../assets/img/flags/en.png" />
        </div>
      </div>
    </div>

    <div class="title-row">
      <div class="header-title">
        <div class="title">Cesta</div>
      </div>
      <div class="back-button-wrapper">
        <button mat-flat-button (click)="goTo('/welcome')">
          <mat-icon>keyboard_arrow_left</mat-icon>
          VOLVER
        </button>
      </div>
    </div>

    <!-- <div class="header-left">

      <div class="header-title">
        {{'buttons.cart' | translate}}
      </div>
    </div>
    <div class="header-right" style="flex-direction: column;">
      <div class="idioma" fxFlex fxLayout="row" fxLayoutAlign="end center">
        <ul fxLayout="row" fxLayoutGap="5px">
          <button mat-menu-item fxLayoutAlign="left center" id="idioma" (click)="changeLang('es')" mat-menu-item><img
              id="idioma" src="../../../assets/img/flags/es.png"></button>
          <button mat-menu-item fxLayoutAlign="left center" id="idioma" (click)="changeLang('cat')" mat-menu-item><img
              id="idioma" src="../../../assets/img/flags/cat.png"></button>
          <button mat-menu-item fxLayoutAlign="left center" id="idioma" (click)="changeLang('en')" mat-menu-item><img
              id="idioma" src="../../../assets/img/flags/en.png"></button>
        </ul>
      </div>
      <div>
        <button>volver</button>
      </div>
    </div> -->
  </div>

  <div class="content">
    <mat-stepper
      orientation="{{ mobileView ? 'vertical' : 'horizontal' }}"
      [linear]="true"
      #stepper
    >
      <!-- SHOPPING CART SUMMARY -->

      <mat-step [stepControl]="firstFormGroup">
        <form [formGroup]="firstFormGroup">
          <ng-template matStepLabel>{{
            "tables.purchase_summary" | translate
          }}</ng-template>

          <!-- DESKTOP VIEW PRODUCT SUMMARY -->
          <mat-table
            *ngIf="!mobileView"
            [dataSource]="dataSource.data"
            class="checkout-table"
          >
            <!-- Photo Column -->
            <ng-container matColumnDef="photo-summary">
              <mat-header-cell
                *matHeaderCellDef
                class="checkout-table-header-cell"
              ></mat-header-cell>
              <mat-cell
                *matCellDef="let product"
                class="checkout-table-cell"
                style="padding-left: 4px"
              >
                <!-- <div mat-card-avatar class="student-avatar" style="background-image: url({{product.url1}})">
                </div> -->
                <div
                  class="student-avatar"
                  style="background-image: url({{ product.url1 }});"
                ></div>
              </mat-cell>
              <mat-footer-cell *matFooterCellDef></mat-footer-cell>
            </ng-container>

            <!-- Description Column -->
            <ng-container matColumnDef="product">
              <mat-header-cell
                *matHeaderCellDef
                class="checkout-table-header-cell"
              >
                <span>{{ "tables.product_name" | translate }}</span>
              </mat-header-cell>
              <mat-cell *matCellDef="let product" class="checkout-table-cell">
                <div class="product-description-wrapper">
                  <div class="product-description-name">
                    <span style="display: {{ 'es' | translate }}">{{
                      product.name_es
                    }}</span>
                    <span style="display: {{ 'en' | translate }}">{{
                      product.name_en
                    }}</span>
                    <span style="display: {{ 'cat' | translate }}">{{
                      product.name_cat
                    }}</span>
                  </div>
                  <div class="product-description-description">
                    <div
                      *ngFor="
                        let description of productDescriptions[product.id]
                      "
                    >
                      <div>
                        <span style="display: {{ 'es' | translate }}"
                          >{{
                            description.unit ? description.unit : "*"
                          }}
                          &nbsp; {{ description.description_es }}</span
                        >
                        <span style="display: {{ 'en' | translate }}"
                          >{{
                            description.unit ? description.unit : "*"
                          }}
                          &nbsp; {{ description.description_en }}</span
                        >
                        <span style="display: {{ 'cat' | translate }}"
                          >{{
                            description.unit ? description.unit : "*"
                          }}
                          &nbsp; {{ description.description_cat }}</span
                        >
                      </div>
                    </div>
                  </div>

                  <!-- <mat-progress-bar
                    *ngIf="this.updatingShoppingCart.updating && this.updatingShoppingCart.itemId == product.id"
                    style="width: 98%; margin-top: 24px;" mode="indeterminate">
                  </mat-progress-bar> -->
                </div>
              </mat-cell>
              <mat-footer-cell *matFooterCellDef> </mat-footer-cell>
            </ng-container>

            <ng-container matColumnDef="description">
              <mat-header-cell
                *matHeaderCellDef
                class="checkout-table-header-cell"
              >
                <span>{{ "tables.description" | translate }}</span>
              </mat-header-cell>
              <mat-cell *matCellDef="let product" class="checkout-table-cell">
                {{
                  product.album_id
                    ? product.name[product.album_id].join(", ") + "."
                    : product.shopping_description
                }}
                <!-- <div *ngIf="!product.album_id">
                  {{ product.shopping_description }}
                </div>
                <div *ngIf="product.album_id">
                  <span *ngFor="let name of product.name">{{ name }} </span>
                </div> -->
              </mat-cell>
              <mat-footer-cell *matFooterCellDef></mat-footer-cell>
            </ng-container>

            <ng-container matColumnDef="grade">
              <mat-header-cell
                *matHeaderCellDef
                class="checkout-table-header-cell"
              >
                <span>{{ "tables.grade" | translate }}</span>
              </mat-header-cell>
              <mat-cell *matCellDef="let product" class="checkout-table-cell">
                {{ product.grade_name }}
              </mat-cell>
              <mat-footer-cell *matFooterCellDef></mat-footer-cell>
            </ng-container>

            <ng-container matColumnDef="student">
              <mat-header-cell
                *matHeaderCellDef
                class="checkout-table-header-cell"
              >
                <span>{{ "tables.student_name" | translate }}</span>
              </mat-header-cell>
              <mat-cell *matCellDef="let product" class="checkout-table-cell">
                {{ product.student_name }}
              </mat-cell>
              <mat-footer-cell *matFooterCellDef></mat-footer-cell>
            </ng-container>

            <ng-container matColumnDef="unit_pvp">
              <mat-header-cell
                *matHeaderCellDef
                class="checkout-table-header-cell"
              >
                <span>{{ "tables.unit_pvp" | translate }} </span>
              </mat-header-cell>
              <mat-cell *matCellDef="let product" class="checkout-table-cell">
                {{ product.value }} € <br />
                {{ "tables.vat_included" | translate }}
              </mat-cell>
              <mat-footer-cell *matFooterCellDef>
                <div>
                  <span style="font-size: 14px; color: black; float: right"
                    >{{ "inputs.subtotal" | translate }}: {{ subtotal }}€</span
                  >
                  <br />
                  <span style="font-size: 14px; color: black; float: right"
                    >{{ "inputs.value_shipping" | translate }}:
                    {{ value_shipping }}€</span
                  >
                  <span style="font-size: 14px; color: black; float: right"
                    >({{ num_products }}
                    {{ "inputs.products" | translate }})</span
                  >
                  <br /><br /><br />

                  <span class="total-checkout" style="float: right"
                    >Total: {{ totalAmount.toFixed(2) }}€ <br />
                    <span style="font-size: 14px; color: black; float: right">{{
                      "tables.vat_included" | translate
                    }}</span>
                  </span>
                </div>
              </mat-footer-cell>
            </ng-container>

            <ng-container matColumnDef="quantity">
              <mat-header-cell
                *matHeaderCellDef
                class="checkout-table-header-cell quantity-header"
              >
                <span> {{ "tables.unit" | translate }}</span>
              </mat-header-cell>
              <mat-cell
                *matCellDef="let product"
                class="checkout-table-cell quantity-cell"
              >
                <div>
                  <button mat-button [matMenuTriggerFor]="summaryMenu" [disabled]="product.is_gift == true">
                    {{ product.quantity }}
                    <mat-icon> keyboard_arrow_down</mat-icon>
                  </button>
                  <!-- MENU FOR QUANTITY EDITION IN SUMMARY CHART -->
                  <mat-menu #summaryMenu="matMenu">
                    <div style="height: 200px; text-align: center">
                      <button
                        *ngIf="!product.album_id"
                        mat-menu-item
                        (click)="
                          updateProductQuantity(
                            0,
                            product.id,
                            product.student_id,
                            product.photo_id
                          )
                        "
                        style="text-align: center"
                      >
                        <span>
                          <mat-icon style="margin: 0">delete</mat-icon>
                        </span>
                      </button>
                      <button
                        *ngIf="product.album_id"
                        mat-menu-item
                        (click)="
                          updateAlbumQuantity(0, product.album_id, product.id)
                        "
                        style="text-align: center"
                      >
                        <span>
                          <mat-icon style="margin: 0">delete</mat-icon>
                        </span>
                      </button>
                      <mat-divider style="width: 100%"></mat-divider>
                      <div *ngFor="let number of numberList">
                        <button
                          *ngIf="!product.album_id"
                          mat-menu-item
                          (click)="
                            updateProductQuantity(
                              number,
                              product.id,
                              product.student_id,
                              product.photo_id
                            )
                          "
                          style="text-align: center"
                        >
                          <span>{{ number }}</span>
                        </button>
                        <button
                          *ngIf="product.album_id"
                          mat-menu-item
                          (click)="
                            updateAlbumQuantity(
                              number,
                              product.album_id,
                              product.id
                            )
                          "
                          style="text-align: center"
                        >
                          <span>{{ number }}</span>
                        </button>
                      </div>
                    </div>
                  </mat-menu>
                </div>
              </mat-cell>
              <mat-footer-cell *matFooterCellDef>
                <div
                  style="width: 100%; display: flex; justify-content: flex-end"
                >
                  <button
                    mat-button
                    matStepperNext
                    style="background-color: #5fbeb5; color: white"
                  >
                    {{ "inputs.next" | translate }}
                  </button>
                </div>
              </mat-footer-cell>
            </ng-container>

            <mat-header-row
              *matHeaderRowDef="displayedColumns"
            ></mat-header-row>
            <mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>
            <mat-footer-row
              *matFooterRowDef="displayedColumns"
            ></mat-footer-row>
          </mat-table>

          <!-- MOBILE VIEW PRODUCT SUMMARY -->
          <div *ngIf="mobileView">
            <div *ngFor="let product of dataSource.data">
              <mat-divider
                style="border-top-color: gray; width: 100%"
              ></mat-divider>

              <div class="product-card">
                <div>
                  <div
                    class="student-avatar-small"
                    style="background-image: url({{ product.url1 }});"
                  ></div>
                  <span>{{ product["student_name"] }}</span>
                  <span>{{ product["grade_name"] }}</span>
                </div>

                <div>
                  <div class="product-name">
                    <span style="display: {{ 'es' | translate }}">{{
                      product.name_es
                    }}</span>
                    <span style="display: {{ 'en' | translate }}">{{
                      product.name_en
                    }}</span>
                    <span style="display: {{ 'cat' | translate }}">{{
                      product.name_cat
                    }}</span>
                  </div>

                  <div class="product-descriptions">
                    <div
                      *ngFor="
                        let description of productDescriptions[product.id]
                      "
                    >
                      <div>
                        <span style="display: {{ 'es' | translate }}"
                          >{{
                            description.unit ? description.unit : "*"
                          }}
                          &nbsp; {{ description.description_es }}</span
                        >
                        <span style="display: {{ 'en' | translate }}"
                          >{{
                            description.unit ? description.unit : "*"
                          }}
                          &nbsp; {{ description.description_en }}</span
                        >
                        <span style="display: {{ 'cat' | translate }}"
                          >{{
                            description.unit ? description.unit : "*"
                          }}
                          &nbsp; {{ description.description_cat }}</span
                        >
                      </div>
                    </div>
                  </div>

                  <div>
                    <div class="product-price">
                      <span>
                        <span style="color: gray"
                          >{{ "inputs.value" | translate }}:
                        </span>
                        {{ product["value"] }} €
                      </span>
                    </div>
                    <div class="product-quantity">
                      <span style="color: gray"
                        >{{ "buttons.quantity_short" | translate }}:</span
                      >
                      <button mat-button [matMenuTriggerFor]="summaryMenu" [disabled]="product.is_gift == true">
                        {{ product.quantity }}
                        <mat-icon> keyboard_arrow_down</mat-icon>
                      </button>
                      <mat-menu #summaryMenu="matMenu">
                        <div style="height: 200px; text-align: center">
                          <button
                            *ngIf="!product.album_id"
                            mat-menu-item
                            (click)="
                              updateProductQuantity(
                                0,
                                product.id,
                                product.student_id,
                                product.photo_id
                              )
                            "
                            style="text-align: center"
                          >
                            <span>
                              <mat-icon style="margin: 0">delete</mat-icon>
                            </span>
                          </button>
                          <button
                            *ngIf="product.album_id"
                            mat-menu-item
                            (click)="
                              updateAlbumQuantity(0, product.album_id, product.id)
                            "
                            style="text-align: center"
                          >
                            <span>
                              <mat-icon style="margin: 0">delete</mat-icon>
                            </span>
                          </button>
                          <mat-divider style="width: 100%"></mat-divider>
                          <div *ngFor="let number of numberList">
                            <button
                              mat-menu-item
                              (click)="
                                updateProductQuantity(
                                  number,
                                  product.id,
                                  product.student_id,
                                  product.photo_id
                                )
                              "
                              style="text-align: center"
                            >
                              <span>{{ number }}</span>
                            </button>
                          </div>
                        </div>
                      </mat-menu>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- <div class="product-card">
              <div class="product-card-column">
                <div class="student-avatar-small" style="background-image: url({{product.url1}});"></div>
                <span>{{product['student_name']}}</span>
                <span>{{product['grade_name']}}</span>
              </div>
              <div class="product-card-column text">
                <div class="product-name">
                  <span style="display: {{'es' | translate}}">{{product.name_es}}</span>
                  <span style="display: {{'en' | translate}}">{{product.name_en}}</span>
                  <span style="display: {{'cat' | translate}}">{{product.name_cat}}</span>
                </div>
                <div class="product-price">
                  <span><span style="color: gray;">{{ 'inputs.value' | translate }}: </span> {{product['value']}}
                    €</span>
                </div>
                <div class="product-quantity">
                  <div>
                    <span style="color: gray;">{{ 'buttons.quantity_short' | translate }}:</span>
                    <button mat-button [matMenuTriggerFor]="summaryMenu">{{ product.quantity }} <mat-icon>
                        keyboard_arrow_down</mat-icon></button>
                    <mat-menu #summaryMenu="matMenu">
                      <div style="height: 200px; text-align: center;">
                        <button mat-menu-item (click)="updateProductQuantity(0, product.id, product.student_id)"
                          style="text-align: center;">
                          <span>
                            <mat-icon style="margin: 0;">delete</mat-icon>
                          </span>
                        </button>
                        <mat-divider style="width: 100%;"></mat-divider>
                        <div *ngFor="let number of numberList">
                          <button mat-menu-item (click)="updateProductQuantity(number, product.id, product.student_id)"
                            style="text-align: center;">
                            <span>{{number}}</span></button>
                        </div>
                      </div>
                    </mat-menu>
                  </div>
                </div>
              </div>
              <div class="product-card-description-column text">
                <div *ngFor="let description of productDescriptions[product.id]">
                  <div>
                    <span style="display: {{'es' | translate}}">{{ description.unit ?
                      description.unit : '*' }} &nbsp;
                      {{description.description_es}}</span>
                    <span style="display: {{'en' | translate}}">{{ description.unit ?
                      description.unit : '*' }} &nbsp;
                      {{description.description_en}}</span>
                    <span style="display: {{'cat' | translate}}">{{ description.unit ?
                      description.unit : '*' }} &nbsp;
                      {{description.description_cat}}</span>
                  </div>
                </div>
              </div>
            </div> -->
          </div>
        </form>
      </mat-step>

      <!-- SHIPPING INFORMATION -->

      <mat-step *ngIf="hasShipping" [stepControl]="shippingInformationForm">
        <ng-template matStepLabel>{{
          "inputs.shipping_address" | translate
        }}</ng-template>

        <div
          class="personal-information-form"
          [formGroup]="shippingInformationForm"
        >
          <div class="personal-information-row">
            <span>{{ "inputs.shipping_address" | translate }}:</span>
            <div>
              <mat-form-field appearance="outline">
                <input
                  matInput
                  type="text"
                  [formControlName]="'address'"
                  placeholder="Ex. Avenida Pablo Ruiz Picasso 1"
                  required
                />
                <mat-hint>{{ "inputs.address" | translate }}</mat-hint>
              </mat-form-field>
            </div>
          </div>
          <div class="personal-information-row">
            <span>{{ "inputs.postal_code" | translate }}:</span>
            <div>
              <mat-form-field appearance="outline">
                <input
                  matInput
                  type="text"
                  [formControlName]="'postal_code'"
                  required
                />
              </mat-form-field>
            </div>
          </div>
          <div class="personal-information-row">
            <span>{{ "inputs.location" | translate }}:</span>
            <mat-form-field appearance="outline">
              <input
                matInput
                type="text"
                [formControlName]="'city'"
                placeholder="Ex. Valencia"
                required
              />
              <mat-hint>{{ "inputs.city" | translate }}</mat-hint>
            </mat-form-field>
            <mat-form-field appearance="outline">
              <input
                matInput
                type="text"
                [formControlName]="'country'"
                placeholder="Ex. España"
                required
              />
              <mat-hint>{{ "inputs.country" | translate }}</mat-hint>
            </mat-form-field>
          </div>
        </div>

        <div *ngIf="!mobileView" style="margin-top: 20px">
          <button
            mat-button
            matStepperPrevious
            style="border: 1px solid black; margin-right: 30%"
          >
            {{ "inputs.back" | translate }}
          </button>
          <button
            mat-button
            matStepperNext
            style="
              background-color: #5fbeb5;
              float: right;
              color: white;
              border: 1px solid #5fbeb5;
            "
            (click)="showErrorSnackbar(shippingInformationForm)"
          >
            {{ "inputs.next" | translate }}
          </button>
          <div class="summary">
            <span style="font-size: 14px; color: black; float: right"
              >{{ "inputs.subtotal" | translate }}: {{ subtotal }}€</span
            >
            <br />
            <span style="font-size: 14px; color: black; float: right"
              >{{ "inputs.value_shipping" | translate }}:
              {{ value_shipping }}€</span
            >
            <br />
            <span style="font-size: 14px; color: black; float: right"
              >({{ num_products }} {{ "inputs.products" | translate }})</span
            >
            <br /><br />
            <span class="total-checkout" style="float: right"
              >Total: {{ totalAmount.toFixed(2) }}€ <br />
              <span style="font-size: 14px; color: black; float: right">{{
                "tables.vat_included" | translate
              }}</span>
            </span>
          </div>
        </div>
      </mat-step>

      <!-- PERSONAL INFORMATION -->

      <mat-step [stepControl]="personalInformationForm">
        <ng-template matStepLabel>{{
          "inputs.personal_data" | translate
        }}</ng-template>
        <div
          class="personal-information-form"
          [formGroup]="personalInformationForm"
        >
          <div class="personal-information-row">
            <span>{{ "inputs.complete_name" | translate }}:</span>
            <div>
              <mat-form-field appearance="outline">
                <input
                  matInput
                  type="text"
                  [formControlName]="'name'"
                  required
                />
                <mat-hint>{{ "inputs.name" | translate }}</mat-hint>
              </mat-form-field>
              <mat-form-field appearance="outline">
                <input
                  matInput
                  type="text"
                  [formControlName]="'surname'"
                  required
                />
                <mat-hint>{{ "inputs.surname" | translate }}</mat-hint>
              </mat-form-field>
            </div>
          </div>
          <div class="personal-information-row">
            <span>{{ "inputs.identifier" | translate }}:</span>
            <mat-form-field appearance="outline">
              <input
                matInput
                type="text"
                [formControlName]="'id_num'"
                required
              />
              <mat-hint>{{ "inputs.identifier_type" | translate }}</mat-hint>
            </mat-form-field>
          </div>
          <div class="personal-information-row">
            <span>{{ "inputs.contact_phone" | translate }}:</span>
            <mat-form-field appearance="outline">
              <input
                matInput
                type="tel"
                [formControlName]="'tel_num'"
                required
              />
              <mat-hint>{{ "inputs.phone" | translate }}</mat-hint>
            </mat-form-field>
          </div>
          <div class="personal-information-row" *ngIf="!hasShipping">
            <span></span>
            <div
              style="flex-direction: row"
              style="display: {{ 'es' | translate }}"
            >
              *{{ no_shipping_txt_es }}
            </div>
            <div
              style="flex-direction: row"
              style="display: {{ 'en' | translate }}"
            >
              *{{ no_shipping_txt_en }}
            </div>
            <div
              style="flex-direction: row"
              style="display: {{ 'cat' | translate }}"
            >
              *{{ no_shipping_txt_cat }}
            </div>
          </div>
          <div class="personal-information-row">
            <span></span>
            <div style="flex-direction: row">
              <mat-checkbox
                [formControlName]="'accept_conditions'"
              ></mat-checkbox>
              &nbsp; &nbsp;
              <a
                href="https://www.makneticfoto.com/condiciones-venta/"
                target="_blank"
                style="color: black; font-size: 16px; display: {{
                  'es' | translate
                }}"
                >{{ "inputs.terms_accept_message" | translate }}</a
              >
              <a
              href="https://makneticfoto.com/terms-and-conditions-of-sale"
                target="_blank"
                style="color: black; font-size: 16px; display: {{
                  'en' | translate
                }}"
                >{{ "inputs.terms_accept_message" | translate }}</a
              >
              <a
              href="https://makneticfoto.com/condicions-de-venda"
                target="_blank"
                style="color: black; font-size: 16px; display: {{
                  'cat' | translate
                }}"
                >{{ "inputs.terms_accept_message" | translate }}</a
              >
            </div>
          </div>

          <!-- <div class="personal-information-row">
              <span></span>
              <button mat-flat-button style="background-color: #5fbeb5;"
                  (click)="checkoutHandler(reservationDataForm)">
                  <span style="color: white;">Reservar</span>
              </button>

          </div> -->
          <div *ngIf="!mobileView" style="margin-top: 20px">
            <button
              mat-button
              matStepperPrevious
              style="border: 1px solid black; margin-right: 30%"
            >
              {{ "inputs.back" | translate }}
            </button>
            <div *ngIf="!hasShipping" style="
            float: right;
            display: flex;
            flex-direction: column;
            ">
              <button
                mat-button
                style="
                  background-color: #5fbeb5;
                  color: white;
                  height: 47px;
                  border: 1px solid #5fbeb5;
                "
                (click)="paymentTPV(personalInformationForm)"> <mat-icon matPrefix>credit_card</mat-icon> {{ "inputs.proceed_payment" | translate }} </button>

              <button mat-button 
              style="background-image: url('../../../assets/img/boton_bizum.png');
              background-repeat: no-repeat;
              background-size: cover;
              width: 159.69px;
              height: 47px;
              margin-top: 20px;" (click)="paymentTPV(personalInformationForm, null, true)">
              </button>
            </div>
            <div *ngIf="hasShipping" style="
            float: right;
            display: flex;
            flex-direction: column;
            ">
              <button
                mat-button
                style="
                  background-color: #5fbeb5;
                  color: white;
                  border: 1px solid #5fbeb5;
                  height: 47px;
                "
                (click)="paymentTPV(personalInformationForm, shippingInformationForm)"><mat-icon matPrefix>credit_card</mat-icon> {{ "inputs.proceed_payment" | translate }} </button>
              <button mat-button 
              style="background-image: url('../../../assets/img/boton_bizum.png');
              background-repeat: no-repeat;
              background-size: cover;
              width: 159.69px;
              height: 47px;
              margin-top: 20px;" (click)="paymentTPV(personalInformationForm, shippingInformationForm, true)">
              </button>
            </div>

            <div class="summary">
              <span style="font-size: 14px; color: black; float: right"
                >{{ "inputs.subtotal" | translate }}: {{ subtotal }}€</span
              >
              <br />
              <span style="font-size: 14px; color: black; float: right"
                >{{ "inputs.value_shipping" | translate }}:
                {{ value_shipping }}€</span
              >
              <br />
              <span style="font-size: 14px; color: black; float: right"
                >({{ num_products }} {{ "inputs.products" | translate }})</span
              >

              <br /><br />
              <span class="total-checkout" style="float: right"
                >Total: {{ totalAmount.toFixed(2) }}€ <br />
                <span style="font-size: 14px; color: black; float: right">{{
                  "tables.vat_included" | translate
                }}</span>
              </span>
            </div>
          </div>
        </div>
      </mat-step>
    </mat-stepper>

    <app-footer></app-footer>
  </div>

  <div
    *ngIf="mobileView"
    class="floating-footer" [ngStyle]="{'padding-bottom': smallFooter? '0px' : '15px'}"
    [ngClass]="{ 'floating-footer-small': smallFooter }"
  >
    <div class="close-btn-wrapper">
      <button mat-icon-button (click)="smallFooter = !smallFooter">
        <mat-icon>{{
          !smallFooter ? "keyboard_arrow_down" : "keyboard_arrow_up"
        }}</mat-icon>
      </button>
    </div>

    <div *ngIf="!smallFooter">
      <div class="footer-price-info">
        <span style="font-size: 14px; color: black; float: right"
          >{{ "inputs.subtotal" | translate }}: {{ subtotal }}€</span
        >

        <span style="font-size: 14px; color: black; float: right"
          >{{ "inputs.value_shipping" | translate }}:
          {{ value_shipping }}€</span
        >
        <span style="font-size: 14px; color: black; float: right"
          >({{ num_products }} {{ "inputs.products" | translate }} )</span
        >
        <span class="total-checkout"
          >Total: {{ totalAmount.toFixed(2) }}€ <br />
          <span style="font-size: 14px; color: black; float: right">{{
            "tables.vat_included" | translate
          }}</span>
        </span>
      </div>
    </div>

    <div *ngIf="currentStep == 0" class="action-btn-wrapper">
      <button mat-button (click)="goBack(stepper)" class="action-btn-back">
        {{ "inputs.back" | translate }}
      </button>
      <button mat-button (click)="goForward(stepper)" class="action-btn-next">
        {{ "inputs.next" | translate }}
      </button>
    </div>

    <div *ngIf="hasShipping && currentStep == 1" class="action-btn-wrapper">
      <button mat-button (click)="goBack(stepper)" class="action-btn-back">
        {{ "inputs.back" | translate }}
      </button>
      <button
        mat-button
        class="action-btn-next"
        (click)="showErrorSnackbar(shippingInformationForm); goForward(stepper)"
      >
        {{ "inputs.next" | translate }}
      </button>
    </div>

    <div
      *ngIf="currentStep == 2 || (!hasShipping && currentStep == 1)"
      class="action-btn-wrapper"
    >
      <button mat-button (click)="goBack(stepper)" class="action-btn-back">
        {{ "inputs.back" | translate }}
      </button>
      <div  *ngIf="!hasShipping" class="pay-buttons-container">
        <button
          mat-button
          class="action-btn-next"
          (click)="smallFooter? smallFooter = !smallFooter : paymentTPV(personalInformationForm)"
        >
          <mat-icon matPrefix *ngIf="!smallFooter">credit_card</mat-icon>
          {{ "inputs.proceed_payment" | translate }}
        </button>


        <button mat-button *ngIf="!smallFooter"
        style="background-image: url('../../../assets/img/boton_bizum.png');
        background-repeat: no-repeat;
        background-size: cover;
        width: 159.69px;
        height: 48px;
        margin-top: 20px;" (click)="paymentTPV(personalInformationForm, null, true)">
        </button>
      </div>
      <div *ngIf="hasShipping" class="pay-buttons-container">
        <button
          mat-button
          class="action-btn-next"
          (click)="smallFooter? smallFooter = !smallFooter : paymentTPV(personalInformationForm, shippingInformationForm)"
        >
          <mat-icon matPrefix *ngIf="!smallFooter">credit_card</mat-icon>
          {{ "inputs.proceed_payment" | translate }}
        </button>

        <button mat-button *ngIf="!smallFooter"
        style="background-image: url('../../../assets/img/boton_bizum.png');
        background-repeat: no-repeat;
        background-size: cover;
        width: 159.69px;
        height: 48px;
        margin-top: 20px;" (click)="paymentTPV(personalInformationForm, shippingInformationForm, true)">
        </button>
      </div>
    </div>
  </div>
</div>
